import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import logo from "../../assets/dhanvanti.png";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        
        {/* Brand */}
        <img src={logo} alt="Dhanvanti Logo" style={{ height: "100px" }}/>

        {/* Navigation */}
        <nav className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/leadership">Leadership</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/blog">Blog</Link>
        </nav>

        {/* Social Icons */}
        <div className="footer-social">
          <a href="https://www.facebook.com/profile.php?id=61559684253885&mibextid=wwXIfr&rdid=DOMTHVSdYsedvsj8&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18HJQUS2zL%2F%3Fmibextid%3DwwXIfr#" target="_blank"
            rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://www.instagram.com/dhanvantiluxurybuilders?igsh=MjdodTk1NDdoMmtk" target="_blank"
            rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.linkedin.com/company/dhanvantiluxurybuilders" target="_blank"
            rel="noopener noreferrer"><FaLinkedinIn /></a>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom */}
        <div className="footer-bottom">
          <p>
            © 2026 Made by Zebrians Creative Tribe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;